import React, { useEffect, useMemo, useState } from 'react';
import { Button, DatePicker, Input, Modal, Switch, TimePicker, Typography } from 'antd';
import dayjs from 'dayjs';
import { formatDate, formatDateToISO } from './Utilitiy';

const { Text } = Typography;

const buildDayjsFromShift = (dateValue, timeValue) => {
  if (!dateValue) {
    return dayjs();
  }

  const isoDate = formatDateToISO(dateValue);
  if (!timeValue) {
    return dayjs(isoDate);
  }

  return dayjs(`${isoDate} ${timeValue}`, 'YYYY-MM-DD HH:mm');
};

const UnavailabilityModal = ({
  open,
  onClose,
  onSave,
  selectedBookedItem,
  staffId,
}) => {
  const defaultStart = useMemo(
    () => buildDayjsFromShift(selectedBookedItem?.date, selectedBookedItem?.starttime),
    [selectedBookedItem?.date, selectedBookedItem?.starttime]
  );
  const defaultEnd = useMemo(
    () => buildDayjsFromShift(selectedBookedItem?.date, selectedBookedItem?.endtime),
    [selectedBookedItem?.date, selectedBookedItem?.endtime]
  );

  const [allDay, setAllDay] = useState(false);
  const [repeat, setRepeat] = useState(false);
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [startTime, setStartTime] = useState(defaultStart);
  const [endTime, setEndTime] = useState(defaultEnd);
  const [reason, setReason] = useState("Can't work");

  useEffect(() => {
    setAllDay(false);
    setRepeat(false);
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setStartTime(defaultStart);
    setEndTime(defaultEnd);
    setReason("Can't work");
  }, [defaultEnd, defaultStart, open]);

  const handleSave = () => {
    const payload = {
      id: null,
      type: 'U',
      staffId,
      startDate: formatDate(startDate.toDate()),
      endDate: formatDate(endDate.toDate()),
      allDay,
      repeat,
      reason,
      starttime: allDay ? '00:00' : startTime.format('HH:mm'),
      endtime: allDay ? '23:59' : endTime.format('HH:mm'),
      repeatSettings: repeat ? {
        every: 'Week',
        on: startDate.format('dddd'),
        ends: 'Never',
      } : null,
    };

    onSave(payload);
  };

  return (
    <Modal open={open} onCancel={onClose} footer={null} title="Can't work / Unavailability">
      <div style={{ display: 'grid', gap: 16 }}>
        <div style={{ display: 'grid', gap: 8 }}>
          <Text strong>Reason</Text>
          <Input value={reason} onChange={(event) => setReason(event.target.value)} />
        </div>

        <div style={{ display: 'flex', gap: 16 }}>
          <div style={{ display: 'grid', gap: 8 }}>
            <Text strong>All day</Text>
            <Switch checked={allDay} onChange={setAllDay} />
          </div>
          <div style={{ display: 'grid', gap: 8 }}>
            <Text strong>Repeat weekly</Text>
            <Switch checked={repeat} onChange={setRepeat} />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1, display: 'grid', gap: 8 }}>
            <Text strong>Start date</Text>
            <DatePicker value={startDate} onChange={(value) => value && setStartDate(value)} format="DD-MM-YYYY" />
          </div>
          <div style={{ flex: 1, display: 'grid', gap: 8 }}>
            <Text strong>End date</Text>
            <DatePicker value={endDate} onChange={(value) => value && setEndDate(value)} format="DD-MM-YYYY" />
          </div>
        </div>

        {!allDay ? (
          <div style={{ display: 'flex', gap: 12 }}>
            <div style={{ flex: 1, display: 'grid', gap: 8 }}>
              <Text strong>Start time</Text>
              <TimePicker value={startTime} onChange={(value) => value && setStartTime(value)} format="HH:mm" />
            </div>
            <div style={{ flex: 1, display: 'grid', gap: 8 }}>
              <Text strong>End time</Text>
              <TimePicker value={endTime} onChange={(value) => value && setEndTime(value)} format="HH:mm" />
            </div>
          </div>
        ) : null}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleSave}>Save unavailability</Button>
        </div>
      </div>
    </Modal>
  );
};

export default UnavailabilityModal;